import {
  createClient,
  i18n,
  AuthProvider,
  AnalyticsProvider,
  captureObservabilityError,
  DebugLoggingProvider,
} from '@psyomics/ui-common';
import { BackgroundProvider, DebugLogs, GenericError } from '@psyomics/ui-components';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Provider as UrqlProvider } from 'urql';

import { getConfig } from '../config';
import { LandingContext } from '../shared/contexts/landing-context';
import { PatientAppBarProvider } from '../shared/contexts/patient-app-bar';

import { AuthRoutes } from './auth-routes';

const config = getConfig();

export const renderRoot = () => {
  const htmlElement = document.getElementById('root');

  if (!htmlElement) {
    throw Error('no root dom element');
  }

  const root = ReactDOM.createRoot(htmlElement);
  const { patientApiUrl, patientApiClientId, patientApiCognitoDomain, postHogApiKey, postHogHost } = config;

  root.render(
    <StrictMode>
      <DebugLoggingProvider enabled={config.debugLogsEnabled}>
        <>
          <AnalyticsProvider apiKey={postHogApiKey} host={postHogHost}>
            <BrowserRouter>
              <BackgroundProvider>
                <ErrorBoundary fallback={<GenericError />} onError={captureObservabilityError}>
                  <I18nextProvider i18n={i18n}>
                    <AuthProvider
                      apiUrl={patientApiUrl}
                      clientId={patientApiClientId}
                      cognitoDomain={patientApiCognitoDomain}
                    >
                      <UrqlProvider value={createClient(`${patientApiUrl}/graphql`)}>
                        <PatientAppBarProvider>
                          <LandingContext>
                            <AuthRoutes />
                          </LandingContext>
                        </PatientAppBarProvider>
                      </UrqlProvider>
                    </AuthProvider>
                  </I18nextProvider>
                </ErrorBoundary>
              </BackgroundProvider>
            </BrowserRouter>
          </AnalyticsProvider>
          <DebugLogs />
        </>
      </DebugLoggingProvider>
    </StrictMode>
  );
};
